export default {
  containerStyle: {
    display: "flex",
    margin: "1rem 0 2rem 0",
  },
};
